import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";

const items = [
  "Partex Aeromarine",
  "iDataHost",
  "Onuchrom",
  "Vromon Golpo",
  "CAIE Biology",
  "Maraz Chemistry",
  "BD Mushroom Project",
];

function MarqueeStrip({ speedSeconds = 40 }) {
  return (
    <section className="relative overflow-hidden select-none py-6 sm:py-8">
      {/* Angled dark strip */}
      <div className="relative -rotate-2 scale-110 bg-[#141414] text-white overflow-hidden border-y-2 border-[#f9836b]">
        <div className="marquee whitespace-nowrap py-3.5">
          <div
            className="marquee__track inline-flex items-center gap-10"
            style={{ animationDuration: `${speedSeconds}s` }}
          >
            {Array(3)
              .fill(null)
              .flatMap((_, block) =>
                items.map((label, idx) => (
                  <span
                    key={`${label}-${block}-${idx}`}
                    className="inline-flex items-center gap-4 text-lg sm:text-xl font-extrabold tracking-wide text-gray-100"
                  >
                    {label}
                    <HiOutlineSparkles
                      className="text-xl"
                      style={{ color: "#f9836b" }}
                    />
                  </span>
                ))
              )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default MarqueeStrip;
